import React, { useState } from "react";
import "./confirmEmail.css";
import ConfirmEmailImg from "./assets/confirmEmail.png";
import SignupToolbar from "../../components/lawyerToolbar/signupToolbar";
import DeterminateProgress from "../../components/input/new/determinateProgress";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../supabaseClient"; // Adjust the import path as needed

export default function ConfirmEmail() {
  const navigate = useNavigate();

  const attorney = useSelector((state) => state.attorney); // Get all lawyer info from Redux
  const email = attorney.email;

  const handleContinue = async () => {
    const {
      data: { user },
      error,
    } = await supabase.auth.getUser();
    if (error || !user) {
      alert("Unable to get user info.");
      return;
    }

    // If email_confirmed_at is null, they haven’t clicked the link yet
    if (!user.email_confirmed_at) {
      alert("Please verify your email before continuing.");
      return;
    }

    // Now that we know their email is confirmed, go ahead
    navigate("/grow/login");
  };
  return (
    <div>
      <SignupToolbar onlyHelp={true} />
      <div className="confirm-email-container">
        {/* Main content area */}
        <div className="main-content">
          <div className="card-confirm-email">
            <div className="icon-wrapper">
              <img
                src={ConfirmEmailImg}
                alt="Confirm Email Icon"
                className="confirm-email-img"
              />

              {/* Heading */}
              <h2 className="email-title">Confirm your email address</h2>
              <p className="email-content">We sent a link to {email}</p>
              <p className="email-content">
                Click on the link to confirm your email address.
              </p>
              <hr style={{ width: "280px", background: "#E2E2E2" }} />
              <div style={{ marginTop: "20px" }}>
                <p className="email-content">
                  Didn’t get an email?
                  <span>Resend</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom navigation bar */}
        <DeterminateProgress value={40} />

        <div className="bottom-bar">
          <div className="bottom-bar-left">
            <span className="section-label">Email Confirmation</span>
            <span className="step-indicator">Step 2 of 5</span>
          </div>
          <button
            type="button"
            className="continue-btn-email"
            onClick={handleContinue}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
